<template>
    <div>
        <section class="news-notification">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <v-row v-if="loadingNotification">
                            <v-col cols="16">
                                <v-progress-linear :indeterminate="true"></v-progress-linear>
                            </v-col>
                        </v-row>
                        <v-row v-else-if="!loadingNotification && notifications.length === 0">
                            <v-col cols="16">
                                <p>Nemáte žádná upozornění.</p>
                            </v-col>
                        </v-row>
                        <v-row v-else-if="!loadingNotification" v-for="(notification, index) in notifications" :key="notification.id">
                            <v-col cols="16" v-if="index === 0">
                                <h2 class="section-subtitle">Novinky a oznámení</h2>
                            </v-col>
                            <v-col cols="16">
                                <notification-loader
                                    :type="notification.type"
                                    @remove="hideNotification"
                                    :data="notification" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import NotificationLoader from '../Notification/NotificationLoader';
    import { LISTING_REQUEST } from '../../store/actions/notification';

    export default {
        name: 'Notifications',
        components: { NotificationLoader },
        data () {
            return {
                loadingNotification: false,
                notifications: [],
            };
        },
        methods: {
            hideNotification (id) {
                this.$delete(this.notifications, this.notifications.findIndex(obj => obj.id === id));
            },
        },
        async created () {
            try {
                this.loadingNotification = true;
                this.notifications = await this.$store.dispatch('notification/' + LISTING_REQUEST);
            } catch (e) {
                this.$toast.error('Došlo k chybě při načítání notifikací. Zkuste to později.');
            } finally {
                this.loadingNotification = false;
            }
        },
    }
</script>
